export const KIOSK_LOGOFF_BARCODE = 'KioskLogoffBarcode';
export const FONT_SIZE_CUSTOMER_DISPLAY = 'FontSizeCustomerDisplay';
export const DISABLE_PAYMENTS_WITH_INVOICE = 'DisablePaymentsWithInvoice';
export const ENABLE_INFO_REQUIRED_FOR_INVOICE = 'EnableInfoRequiredForInvoice';
export const ENABLE_CUSTOMER_INFO_REQUIRED_FOR_INVOICE = 'EnableCustomerInfoRequiredForInvoice';
export const DISABLE_VATNUMBER_VALIDATION = 'DisableVatNumberValidation';
export const DISCOUNTMENU_ARTICLEID = 'DiscountMenuArticleID';


// WEBPACK FOOTER //
// src/constants/SystemSettings.js